module.exports = __webpack_public_path__ + "static/media/party.80f01a81.png";